export default __webpack_public_path__ + "static/media/banner-achievements.8d762c83.webp";